<template>
  <el-dialog
    :visible.sync="display"
    :close-on-click-modal="false"
    :show-close="false"
    :modal-append-to-body="false"
    center
  >
    <div style="margin: 20px; text-align: center">
      <img src="/img/frameloader.gif" width="48" />
    </div>

    <p>{{ $t('Audiences_Segment_DialogCalculate_Calculating') }}</p>
    <div class="m-top-50">
      <p>{{ $t('Audiences_Segment_DialogCalculate_Question') }}</p>
      <p>
        {{ $t('Audiences_Segment_DialogCalculate_Alert') }}
      </p>
    </div>

    <span slot="footer" class="dialog-footer">
      <!--      <el-button type="danger" plain @click="cancel">
        {{ $t('Audiences_Segment_DialogCalculate_CancelBtn') }}
      </el-button>-->
      <el-button
        type="primary"
        plain
        @click="checkLater"
        data-qa="check-later-button"
      >
        {{ $t('Audiences_Segment_DialogCalculate_LaterBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'

export default {
  name: 'CalculateSizeDialog',
  data() {
    return {
      display: true
    }
  },
  methods: {
    checkLater() {
      EventBus.$emit('calculate-size-hide')
    },
    cancel() {
      EventBus.$emit('calculate-size-cancel')
    }
  }
}
</script>

<style scoped>
p {
  font-size: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/CalculateSizeDialog.vue